import { Injectable } from '@angular/core';
import { ILatLngBounds } from 'src/app/core/models/google-map-models';

export interface IGoogleMapGeoService {
  decode(call): Array<any>;
  bounds(geohash): any;
}

@Injectable({
  providedIn: 'root'
})
export class GoogleMapGeoService implements IGoogleMapGeoService {

  private readonly Geohash: any = {};

  constructor() {
    /* (Geohash-specific) Base32 map */
    this.Geohash.base32 = '0123456789bcdefghjkmnpqrstuvwxyz';
  }

  public centerGeo(geohash): any {
      const bounds = this.bounds(geohash); // <-- the hard work
      // now just determine the centre of the cell...

      const latMin = bounds.sw.lat, lonMin = bounds.sw.lon;
      const latMax = bounds.ne.lat, lonMax = bounds.ne.lon;

      // cell centre
      let lat: any = (latMin + latMax) / 2;
      let lon: any = (lonMin + lonMax) / 2;

      // round to close to centre without excessive precision: ⌊2-log10(Δ°)⌋ decimal places
      lat = lat.toFixed(Math.floor(2 - Math.log(latMax - latMin) / Math.LN10));
      lon = lon.toFixed(Math.floor(2 - Math.log(lonMax - lonMin) / Math.LN10));

      return { lat: Number(lat), lon: Number(lon) };
  }

  public latLngBounds(geohash): ILatLngBounds {
    const bounds = this.bounds(geohash);

    return new google.maps.LatLngBounds(
      new google.maps.LatLng(
        bounds.sw.lat,
        bounds.sw.lon
      ),
      new google.maps.LatLng(
        bounds.ne.lat,
        bounds.ne.lon
      )
    );
  }

  public bounds(geohash): any {
    if (geohash.length === 0) { throw new Error('Invalid geohash'); }

    geohash = geohash.toLowerCase();

    let evenBit = true;
    let latMin =  -90, latMax =  90;
    let lonMin = -180, lonMax = 180;

    for (let i = 0; i < geohash.length; i++) {
        const chr = geohash.charAt(i);
        const idx = this.Geohash.base32.indexOf(chr);
        if (idx == -1) { throw new Error('Invalid geohash'); }

        for (let n = 4; n >= 0; n--) {
            const bitN = idx >> n & 1;
            if (evenBit) {
                // longitude
                const lonMid = (lonMin + lonMax) / 2;
                if (bitN == 1) {
                    lonMin = lonMid;
                } else {
                    lonMax = lonMid;
                }
            } else {
                // latitude
                const latMid = (latMin + latMax) / 2;
                if (bitN == 1) {
                    latMin = latMid;
                } else {
                    latMax = latMid;
                }
            }
            evenBit = !evenBit;
        }
    }

    const bounds = {
        sw: { lat: latMin, lon: lonMin },
        ne: { lat: latMax, lon: lonMax },
    };

    return bounds;
}


  /*
   *Map geo point parsing logic
   */

  public decode(call): Array<any> {
    /*NOT USED IF USING GOOGLE GEO LIBRARY - ONLY AVAILABLE WITH v3.3 of API*/
    let c, i, j, k, l, q, w, x, y;
    const z = new Array();

    if (typeof call !== 'object') {
      call = [call];
    }

    for (i = 0; (q = call[i]); i++) {
      if ((q = q.match(/[\_-\~]*[\?-\^]/g))) {
        for (j = 0, k = 0, x = 0, y = 0; ; j++) {
          if (!q[k]) {
            break;
          }
          for (l = q[k].length, c = 63, w = 0; l--; c = 95) {
            // eslint-disable-next-line no-bitwise
            w = (w << 5) + q[k].charCodeAt(l) - c;
          }
          // eslint-disable-next-line no-bitwise
          y += ((w << 31) >> 31) ^ (w >> 1);
          k++;
          if (!q[k]) {
            break;
          }
          for (l = q[k].length, c = 63, w = 0; l--; c = 95) {
            // eslint-disable-next-line no-bitwise
            w = (w << 5) + q[k].charCodeAt(l) - c;
          }
          // eslint-disable-next-line no-bitwise
          x += ((w << 31) >> 31) ^ (w >> 1);
          k++;
          z.push(new google.maps.LatLng(y * 1e-5, x * 1e-5));
        }
      }
    }

    return z;
  }

}
